import { useState, useEffect } from "react";
import { G, D, D3, D4, BR, TX, T2, PILARES } from "./theme";
import { getCl, initials, genToken } from "./utils";
import { criarLink, buscarLink, listarLinks, listarRespostas, supabase, buscarPerfil, apagarResposta, apagarLink, criarCheckout, contarDiagnosticosMes, atualizarPerfil, criarLinkUniversal } from "./supabase";
import Avatar from "./components/Avatar";
import Sidebar from "./components/Sidebar";
import FormAluno from "./components/FormAluno";
import DashAluno from "./components/DashAluno";
import Config from "./components/Config";
import AdminPanel from "./components/AdminPanel";

export default function App() {
  var [user, setUser] = useState(null);
  var [view, setView] = useState("login");
  var [emailIn, setEmailIn] = useState("");
  var [senhaIn, setSenhaIn] = useState("");
  var [loginErr, setLoginErr] = useState("");
  var [loginLoading, setLoginLoading] = useState(false);
  var [telaLogin, setTelaLogin] = useState("login"); // "login" | "cadastro" | "recuperar"
  var [cadastroMsg, setCadastroMsg] = useState("");
  var [recuperarMsg, setRecuperarMsg] = useState("");
  var [showPwd, setShowPwd] = useState(false);
  var [linkAtivo, setLinkAtivo] = useState(null);
  var [verificandoToken, setVerificandoToken] = useState(true);
  var [alunoSel, setAlunoSel] = useState(null);
  var [mobile, setMobile] = useState(window.innerWidth < 768);

  useEffect(function() {
    function onResize() { setMobile(window.innerWidth < 768); }
    window.addEventListener("resize", onResize);
    return function() { window.removeEventListener("resize", onResize); };
  }, []);
  var [novoNome, setNovoNome] = useState("");
  var [linkGerado, setLinkGerado] = useState(null);
  var [linkUniversal, setLinkUniversal] = useState(null);
  var [configMsg, setConfigMsg] = useState("");
  var [meusLinks, setMeusLinks] = useState([]);
  var [minhasRespostas, setMinhasRespostas] = useState([]);
  var [carregando, setCarregando] = useState(false);
  var [anoSel, setAnoSel] = useState(new Date().getFullYear());
  var [busca, setBusca] = useState("");
  var [filtroClass, setFiltroClass] = useState("todos");
  var [diagnosticosMes, setDiagnosticosMes] = useState(0);
  var [linkInvalido, setLinkInvalido] = useState(false);

  var inp = {width:"100%",background:D3,border:"1px solid "+BR,borderRadius:8,padding:"11px 14px",color:TX,fontSize:14,boxSizing:"border-box",outline:"none"};

  useEffect(function() {
    var params = new URLSearchParams(window.location.search);
    var token = params.get("token");

    async function init() {
      if (token) {
        var lk = await buscarLink(token);
        if (lk) setLinkAtivo(lk);
        else setLinkInvalido(true);
        setVerificandoToken(false);
        return;
      }
      var { data: { session } } = await supabase.auth.getSession();
      if (session) {
        var perfil = await buscarPerfil(session.user.id);
        if (perfil) {
          setUser(Object.assign({}, perfil, { id: session.user.id, email: session.user.email }));
          setView(perfil.role === "admin" ? "admin" : "painel");
        }
      }
      setVerificandoToken(false);
    }
    init();

    var { data: listener } = supabase.auth.onAuthStateChange(function(event, session) {
      if (event === "SIGNED_OUT") {
        setUser(null); setView("login");
        setLinkAtivo(null); setAlunoSel(null); setLinkGerado(null);
        setMeusLinks([]); setMinhasRespostas([]);
      }
    });
    return function() { listener.subscription.unsubscribe(); };
  }, []); // eslint-disable-line

  useEffect(function() {
    if (user && user.role === "coach") carregarDados();
    // Verifica se voltou do Stripe com sucesso
    var params = new URLSearchParams(window.location.search);
    if (params.get("upgrade") === "success") {
      atualizarPerfil(user && user.id, { plano: "pro" }).then(function(){
        setUser(function(prev){ return Object.assign({}, prev, { plano: "pro" }); });
        window.history.replaceState({}, "", window.location.pathname);
      });
    }
  }, [user]); // eslint-disable-line

  async function carregarDados() {
    setCarregando(true);
    var links = await listarLinks(user.id);
    var respostas = await listarRespostas(user.id);
    var count = await contarDiagnosticosMes(user.id);
    setMeusLinks(links || []);
    setMinhasRespostas(respostas || []);
    setDiagnosticosMes(count || 0);
    setCarregando(false);
  }

  async function doLogin() {
    setLoginErr(""); setLoginLoading(true);
    var { data, error } = await supabase.auth.signInWithPassword({ email: emailIn.trim(), password: senhaIn.trim() });
    setLoginLoading(false);
    if (error) {
      if (error.message.includes("Invalid login")) setLoginErr("E-mail ou senha incorretos. Tente novamente.");
      else if (error.message.includes("Email not confirmed")) setLoginErr("E-mail não confirmado. Verifique a sua caixa de entrada.");
      else setLoginErr("Erro ao entrar: " + error.message);
      return;
    }
    if (!data.user) { setLoginErr("Utilizador não encontrado."); return; }
    var perfil = await buscarPerfil(data.user.id);
    if (!perfil) {
      // Primeiro login — cria o perfil automaticamente
      var nome = data.user.email.split("@")[0];
      var av = nome.slice(0,2).toUpperCase();
      var { error: insertErr } = await supabase.from("profiles").insert({
        id: data.user.id, nome: nome, email: data.user.email, role: "coach", avatar: av
      });
      if (insertErr) { setLoginErr("Erro ao criar perfil: " + insertErr.message); return; }
      perfil = await buscarPerfil(data.user.id);
    }
    if (!perfil) { setLoginErr("Erro ao carregar perfil. Tente novamente."); return; }
    setUser(Object.assign({}, perfil, { id: data.user.id, email: data.user.email }));
    setView(perfil.role === "admin" ? "admin" : "painel");
  }

  async function doCadastro() {
    setCadastroMsg("");
    if (!emailIn.trim() || !senhaIn.trim()) { setCadastroMsg("Preencha e-mail e senha."); return; }
    if (senhaIn.trim().length < 6) { setCadastroMsg("A senha deve ter pelo menos 6 caracteres."); return; }
    setLoginLoading(true);
    var { error } = await supabase.auth.signUp({ email: emailIn.trim(), password: senhaIn.trim() });
    setLoginLoading(false);
    if (error) { setCadastroMsg("Erro: " + error.message); return; }
    setCadastroMsg("✓ Conta criada! Verifique o seu e-mail para confirmar o cadastro e depois faça login.");
    setSenhaIn("");
  }

  async function doRecuperar() {
    setRecuperarMsg("");
    if (!emailIn.trim()) { setRecuperarMsg("Introduz o teu e-mail."); return; }
    setLoginLoading(true);
    var { error } = await supabase.auth.resetPasswordForEmail(emailIn.trim(), {
      redirectTo: window.location.origin
    });
    setLoginLoading(false);
    if (error) { setRecuperarMsg("Erro: " + error.message); return; }
    setRecuperarMsg("✓ E-mail de recuperação enviado! Verifica a tua caixa de entrada.");
  }

  async function doLogout() {
    await supabase.auth.signOut();
    setUser(null); setEmailIn(""); setSenhaIn(""); setView("login");
    setLinkAtivo(null); setAlunoSel(null); setLinkGerado(null);
    setMeusLinks([]); setMinhasRespostas([]);
  }

  async function gerarLink() {
    if (!novoNome.trim()) return;
    var token = genToken();
    var link = await criarLink(token, user.id, user.nome, novoNome.trim());
    if (link) {
      setLinkGerado({token:token, id:link.id, alunoNome:novoNome.trim()});
      setNovoNome("");
      carregarDados();
    }
  }

  async function gerarLinkUniversalFn() {
    var token = genToken();
    var link = await criarLinkUniversal(token, user.id, user.nome);
    if (link) {
      setLinkUniversal({token:token, id:link.id});
      carregarDados();
    }
  }

  function salvarConfig(campos) {
    setUser(function(prev){ return Object.assign({}, prev, campos); });
    setConfigMsg("✓ Alterações salvas!"); setTimeout(function(){ setConfigMsg(""); }, 3000);
  }

  var mediaGeral = minhasRespostas.length ? Math.round(minhasRespostas.reduce(function(a,r){ return a + r.media_geral; }, 0) / minhasRespostas.length * 10) / 10 : 0;

  // Loading
  if (verificandoToken) return (
    <div style={{backgroundColor:D,minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center"}}>
      <div style={{color:T2,fontSize:14}}>Carregando...</div>
    </div>
  );

  // Formulário do aluno (via token)
  if (linkAtivo) {
    return <FormAluno link={linkAtivo} onEnviado={function(){ carregarDados(); }} onVoltar={function(){ setLinkAtivo(null); }}/>;
  }

  // Link inválido ou já usado
  if (linkInvalido) return (
    <div style={{backgroundColor:D,minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",padding:"2rem",fontFamily:"Arial,sans-serif",color:TX}}>
      <div style={{maxWidth:400,width:"100%",textAlign:"center"}}>
        <div style={{fontSize:64,marginBottom:16}}>🔒</div>
        <div style={{fontSize:22,fontWeight:700,color:"#fff",marginBottom:8}}>Link indisponível</div>
        <div style={{fontSize:14,color:T2,lineHeight:1.7,marginBottom:24}}>
          Este link de diagnóstico já foi utilizado ou não existe.<br/>
          Contacta o teu profissional para receber um novo link.
        </div>
        <div style={{background:D3,border:"1px solid "+BR,borderRadius:12,padding:"1rem 1.25rem",fontSize:13,color:T2}}>
          💡 Se acabaste de preencher o formulário, a tua avaliação foi enviada com sucesso!
        </div>
      </div>
    </div>
  );

  // Login
  if (view === "login") return (
    <div style={{backgroundColor:D,minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",padding:"2rem",fontFamily:"Arial,sans-serif",color:TX}}>
      <div style={{width:"100%",maxWidth:380}}>
        <div style={{textAlign:"center",marginBottom:32}}>
          <div style={{fontSize:11,color:G,letterSpacing:3,fontWeight:600,marginBottom:8}}>RELATÓRIO METABÓLICO SISTÊMICO</div>
          <div style={{fontSize:36,fontWeight:700,color:"#fff"}}>RMS <span style={{color:G}}>2.0</span></div>
          <div style={{fontSize:13,color:T2,marginTop:4}}>
            {telaLogin==="login" && "Acesse sua conta profissional"}
            {telaLogin==="cadastro" && "Crie a sua conta profissional"}
            {telaLogin==="recuperar" && "Recuperação de senha"}
          </div>
        </div>

        <div style={{background:D3,border:"1px solid "+BR,borderRadius:16,padding:"2rem"}}>

          {/* Campo e-mail — aparece em todas as telas */}
          <div style={{marginBottom:14}}>
            <label style={{fontSize:11,color:T2,display:"block",marginBottom:6}}>E-mail</label>
            <input value={emailIn} onChange={function(e){ setEmailIn(e.target.value); }}
              placeholder="seu@email.com" style={inp}
              onKeyDown={function(e){ if(e.key==="Enter" && telaLogin==="login") doLogin(); }}/>
          </div>

          {/* Senha — apenas login e cadastro */}
          {telaLogin !== "recuperar" && (
            <div style={{marginBottom:18}}>
              <label style={{fontSize:11,color:T2,display:"block",marginBottom:6}}>Senha</label>
              <div style={{position:"relative"}}>
                <input type={showPwd?"text":"password"} value={senhaIn}
                  onChange={function(e){ setSenhaIn(e.target.value); }}
                  placeholder="••••••••" style={{...inp,paddingRight:44}}
                  onKeyDown={function(e){ if(e.key==="Enter" && telaLogin==="login") doLogin(); }}/>
                <button onClick={function(){ setShowPwd(function(p){ return !p; }); }}
                  style={{position:"absolute",right:12,top:"50%",transform:"translateY(-50%)",background:"none",border:"none",color:T2,cursor:"pointer",fontSize:12}}>
                  {showPwd?"ocultar":"ver"}
                </button>
              </div>
            </div>
          )}

          {/* Mensagens de erro/sucesso */}
          {telaLogin==="login" && loginErr && (
            <div style={{fontSize:12,color:"#E53935",marginBottom:14,background:"#E5393511",border:"1px solid #E5393533",borderRadius:8,padding:"10px 12px"}}>
              ⚠️ {loginErr}
            </div>
          )}
          {telaLogin==="cadastro" && cadastroMsg && (
            <div style={{fontSize:12,color:cadastroMsg.startsWith("✓")?"#4CAF50":"#E53935",marginBottom:14,
              background:cadastroMsg.startsWith("✓")?"#4CAF5011":"#E5393511",
              border:"1px solid "+(cadastroMsg.startsWith("✓")?"#4CAF5033":"#E5393533"),
              borderRadius:8,padding:"10px 12px"}}>
              {cadastroMsg}
            </div>
          )}
          {telaLogin==="recuperar" && recuperarMsg && (
            <div style={{fontSize:12,color:recuperarMsg.startsWith("✓")?"#4CAF50":"#E53935",marginBottom:14,
              background:recuperarMsg.startsWith("✓")?"#4CAF5011":"#E5393511",
              border:"1px solid "+(recuperarMsg.startsWith("✓")?"#4CAF5033":"#E5393533"),
              borderRadius:8,padding:"10px 12px"}}>
              {recuperarMsg}
            </div>
          )}

          {/* Botão principal */}
          {telaLogin==="login" && (
            <button onClick={doLogin} disabled={loginLoading}
              style={{width:"100%",padding:"13px 0",background:loginLoading?D4:G,color:loginLoading?T2:D,border:"none",borderRadius:9,fontWeight:700,fontSize:15,cursor:loginLoading?"not-allowed":"pointer"}}>
              {loginLoading ? "A entrar..." : "Entrar"}
            </button>
          )}
          {telaLogin==="cadastro" && (
            <button onClick={doCadastro} disabled={loginLoading}
              style={{width:"100%",padding:"13px 0",background:loginLoading?D4:G,color:loginLoading?T2:D,border:"none",borderRadius:9,fontWeight:700,fontSize:15,cursor:loginLoading?"not-allowed":"pointer"}}>
              {loginLoading ? "A criar conta..." : "Criar conta"}
            </button>
          )}
          {telaLogin==="recuperar" && (
            <button onClick={doRecuperar} disabled={loginLoading}
              style={{width:"100%",padding:"13px 0",background:loginLoading?D4:G,color:loginLoading?T2:D,border:"none",borderRadius:9,fontWeight:700,fontSize:15,cursor:loginLoading?"not-allowed":"pointer"}}>
              {loginLoading ? "A enviar..." : "Enviar e-mail de recuperação"}
            </button>
          )}
        </div>

        {/* Links de navegação entre telas */}
        <div style={{textAlign:"center",marginTop:18,display:"flex",flexDirection:"column",gap:8}}>
          {telaLogin==="login" && (
            <>
              <button onClick={function(){ setTelaLogin("recuperar"); setLoginErr(""); }}
                style={{background:"none",border:"none",color:T2,fontSize:12,cursor:"pointer"}}>
                Esqueceste a senha?
              </button>
              <button onClick={function(){ setTelaLogin("cadastro"); setLoginErr(""); }}
                style={{background:"none",border:"none",color:G,fontSize:13,cursor:"pointer",fontWeight:500}}>
                Não tens conta? Regista-te →
              </button>
            </>
          )}
          {(telaLogin==="cadastro" || telaLogin==="recuperar") && (
            <button onClick={function(){ setTelaLogin("login"); setCadastroMsg(""); setRecuperarMsg(""); }}
              style={{background:"none",border:"none",color:T2,fontSize:12,cursor:"pointer"}}>
              ← Voltar ao login
            </button>
          )}
        </div>
      </div>
    </div>
  );

  // Admin
  if (view === "admin") {
    return <AdminPanel onLogout={doLogout}/>;
  }

  // Dashboard do aluno selecionado
  if (alunoSel) {
    return (
      <div style={{display:"flex",height:"100vh",backgroundColor:D,fontFamily:"Arial,sans-serif",color:TX}}>
        <Sidebar user={user} active={view} onNav={function(v){ setView(v); setAlunoSel(null); }} onLogout={doLogout}/>
        <DashAluno aluno={alunoSel} coachNome={user.nome} minhasRespostas={minhasRespostas} onVoltar={function(){ setAlunoSel(null); }}/>
      </div>
    );
  }

  // Painel principal
  return (
    <div style={{display:"flex",height:"100vh",backgroundColor:D,fontFamily:"Arial,sans-serif",color:TX,flexDirection:mobile?"column":"row"}}>
      <Sidebar user={user} active={view} onNav={setView} onLogout={doLogout}/>
      <div style={{flex:1,overflowY:"auto",paddingTop:mobile?0:0}}>

        {view==="painel" && (
          <div style={{padding:"2rem"}}>
            {carregando ? (
              <div style={{color:T2,textAlign:"center",padding:"4rem"}}>Carregando dados...</div>
            ) : (
              <>
                <div style={{marginBottom:24}}>
                  <div style={{fontSize:20,fontWeight:700,color:"#fff",marginBottom:4}}>Bem-vindo, {user && user.nome && user.nome.split(" ")[0]} 👋</div>
                  <div style={{fontSize:13,color:T2}}>Visão geral do seu painel</div>
                </div>
                <div style={{display:"grid",gridTemplateColumns:mobile?"1fr":"repeat(3,1fr)",gap:16,marginBottom:28}}>
                  {[
                    {label:"Alunos avaliados", value:minhasRespostas.length, icon:"👥"},
                    {label:"Links ativos", value:meusLinks.filter(function(l){ return l.is_active; }).length, icon:"🔗"},
                    {label:"Média geral", value:mediaGeral ? mediaGeral+"/10" : "—", icon:"📊"},
                  ].map(function(s){ return (
                    <div key={s.label} style={{background:D3,border:"1px solid "+BR,borderRadius:14,padding:"1.25rem"}}>
                      <div style={{fontSize:24,marginBottom:8}}>{s.icon}</div>
                      <div style={{fontSize:28,fontWeight:700,color:G}}>{s.value}</div>
                      <div style={{fontSize:12,color:T2,marginTop:4}}>{s.label}</div>
                    </div>
                  ); })}
                </div>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
                  <div style={{fontSize:14,fontWeight:600,color:"#fff"}}>Diagnósticos por mês</div>
                  <select value={anoSel} onChange={function(e){ setAnoSel(Number(e.target.value)); }}
                    style={{background:D4,border:"1px solid "+BR,borderRadius:8,padding:"6px 12px",color:TX,fontSize:13,cursor:"pointer",outline:"none"}}>
                    {(function(){
                      var anos = [];
                      minhasRespostas.forEach(function(r){
                        var a = new Date(r.created_at).getFullYear();
                        if (anos.indexOf(a) === -1) anos.push(a);
                      });
                      if (anos.length === 0) anos.push(new Date().getFullYear());
                      anos.sort(function(a,b){ return b-a; });
                      return anos.map(function(a){ return <option key={a} value={a}>{a}</option>; });
                    })()}
                  </select>
                </div>
                {(function(){
                  var meses = ["Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez"];
                  var contagem = new Array(12).fill(0);
                  minhasRespostas.forEach(function(r){
                    var d = new Date(r.created_at);
                    if (d.getFullYear() === anoSel) contagem[d.getMonth()]++;
                  });
                  var maxVal = Math.max.apply(null, contagem) || 1;
                  var totalAno = contagem.reduce(function(a,b){ return a+b; }, 0);
                  var melhorMes = contagem.indexOf(Math.max.apply(null, contagem));

                  return (
                    <div style={{background:D3,border:"1px solid "+BR,borderRadius:14,padding:"1.25rem",marginBottom:28}}>
                      <div style={{display:"flex",gap:16,marginBottom:16,flexWrap:"wrap"}}>
                        <div style={{background:D4,borderRadius:8,padding:"8px 14px",fontSize:12}}>
                          <span style={{color:T2}}>Total em {anoSel}: </span>
                          <span style={{fontWeight:700,color:G}}>{totalAno} diagnósticos</span>
                        </div>
                        {totalAno > 0 && (
                          <div style={{background:D4,borderRadius:8,padding:"8px 14px",fontSize:12}}>
                            <span style={{color:T2}}>Melhor mês: </span>
                            <span style={{fontWeight:700,color:G}}>{meses[melhorMes]} ({contagem[melhorMes]})</span>
                          </div>
                        )}
                      </div>
                      <div style={{display:"flex",alignItems:"flex-end",gap:mobile?4:8,height:120}}>
                        {contagem.map(function(val, i){
                          var altura = maxVal > 0 ? (val / maxVal) * 90 : 0;
                          var eMelhor = val === Math.max.apply(null, contagem) && val > 0;
                          return (
                            <div key={i} style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",gap:4}}>
                              {val > 0 && <div style={{fontSize:10,fontWeight:700,color:eMelhor?G:T2}}>{val}</div>}
                              <div style={{width:"100%",borderRadius:"4px 4px 0 0",
                                background:eMelhor?G:G+"44",
                                height:altura||2,minHeight:val>0?8:2,
                                transition:"height 0.3s"}}/>
                              <div style={{fontSize:mobile?8:10,color:T2,textAlign:"center"}}>{meses[i]}</div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                })()}
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
                  <div style={{fontSize:14,fontWeight:600,color:"#fff"}}>Últimas respostas</div>
                  <button onClick={function(){ setView("links"); }} style={{background:G,color:D,border:"none",borderRadius:8,padding:"9px 18px",fontWeight:600,fontSize:13,cursor:"pointer"}}>+ Gerar diagnóstico</button>
                </div>
                {minhasRespostas.length===0 ? (
                  <div style={{textAlign:"center",padding:"3rem",background:D3,border:"1px solid "+BR,borderRadius:14,color:T2}}><div style={{fontSize:36,marginBottom:10}}>📋</div><div>Nenhuma resposta recebida ainda.</div></div>
                ) : (
                  <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(260px,1fr))",gap:12}}>
                    {minhasRespostas.slice(0,6).map(function(r, i){
                      var cl = getCl(r.media_geral);
                      return (
                        <div key={r.id||i} onClick={function(){ setAlunoSel(r); }} style={{background:D3,border:"1px solid "+BR,borderRadius:14,padding:"1.25rem",cursor:"pointer"}}
                          onMouseEnter={function(e){ e.currentTarget.style.borderColor=G+"55"; }}
                          onMouseLeave={function(e){ e.currentTarget.style.borderColor=BR; }}>
                          <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:12}}>
                            <div style={{display:"flex",alignItems:"center",gap:10}}>
                              <Avatar s={initials(r.aluno_nome)} size={38}/>
                              <div><div style={{fontWeight:600,fontSize:14,color:"#fff"}}>{r.aluno_nome}</div><div style={{fontSize:11,color:T2}}>{new Date(r.created_at).toLocaleDateString("pt-BR")}</div></div>
                            </div>
                            <span style={{fontSize:10,padding:"3px 10px",borderRadius:20,background:cl.bg,color:cl.cor,fontWeight:600}}>{cl.label}</span>
                          </div>
                          <div style={{fontSize:22,fontWeight:700,color:cl.cor}}>{r.media_geral}<span style={{fontSize:12,color:T2,fontWeight:400}}>/10</span></div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </>
            )}
          </div>
        )}

        {view==="alunos" && (
          <div style={{padding:"2rem"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
              <div><div style={{fontSize:20,fontWeight:700,color:"#fff"}}>Alunos</div><div style={{fontSize:12,color:T2}}>{minhasRespostas.length} resposta(s)</div></div>
              <button onClick={function(){ setView("links"); }} style={{background:G,color:D,border:"none",borderRadius:8,padding:"10px 20px",fontWeight:600,fontSize:13,cursor:"pointer"}}>+ Novo diagnóstico</button>
            </div>

            {/* Pesquisa e filtros */}
            <div style={{display:"flex",gap:10,marginBottom:16,flexWrap:"wrap"}}>
              <input
                value={busca}
                onChange={function(e){ setBusca(e.target.value); }}
                placeholder="🔍 Pesquisar aluno..."
                style={{flex:1,minWidth:180,background:D3,border:"1px solid "+BR,borderRadius:9,padding:"10px 14px",color:TX,fontSize:13,outline:"none",boxSizing:"border-box"}}
              />
              {["todos","Ótimo","Bom","Moderado","Em Risco","Crítico"].map(function(f){
                var cores = {Ótimo:"#4CAF50",Bom:G,Moderado:"#FF9800","Em Risco":"#FF5722","Crítico":"#E53935"};
                var ativo = filtroClass === f;
                return (
                  <button key={f} onClick={function(){ setFiltroClass(f); }}
                    style={{padding:"8px 14px",borderRadius:9,border:"1px solid "+(ativo?(cores[f]||G):BR),
                      background:ativo?(cores[f]||G)+"22":"none",
                      color:ativo?(cores[f]||G):T2,
                      fontSize:12,fontWeight:ativo?600:400,cursor:"pointer",whiteSpace:"nowrap"}}>
                    {f === "todos" ? "Todos" : f}
                  </button>
                );
              })}
            </div>

            {(function(){
              var filtrados = minhasRespostas.filter(function(r){
                var matchBusca = r.aluno_nome.toLowerCase().includes(busca.toLowerCase());
                var matchClass = filtroClass === "todos" || r.classificacao === filtroClass;
                return matchBusca && matchClass;
              });

              if (minhasRespostas.length === 0) return (
                <div style={{textAlign:"center",padding:"3rem",background:D3,border:"1px solid "+BR,borderRadius:14,color:T2}}>
                  <div style={{fontSize:36,marginBottom:10}}>📋</div>
                  <div>Nenhuma resposta ainda.</div>
                </div>
              );

              if (filtrados.length === 0) return (
                <div style={{textAlign:"center",padding:"3rem",background:D3,border:"1px solid "+BR,borderRadius:14,color:T2}}>
                  <div style={{fontSize:36,marginBottom:10}}>🔍</div>
                  <div>Nenhum aluno encontrado com esses filtros.</div>
                  <button onClick={function(){ setBusca(""); setFiltroClass("todos"); }}
                    style={{marginTop:14,background:"none",border:"1px solid "+BR,borderRadius:8,padding:"8px 16px",color:T2,fontSize:12,cursor:"pointer"}}>
                    Limpar filtros
                  </button>
                </div>
              );

              return (
                <div style={{display:"flex",flexDirection:"column",gap:10}}>
                  <div style={{fontSize:12,color:T2,marginBottom:4}}>{filtrados.length} resultado(s)</div>
                  {filtrados.map(function(r, i){
                    var cl = getCl(r.media_geral);
                    var scores = r.scores_json;
                    var pior = PILARES.slice().sort(function(a,b){ return scores[a.key]-scores[b.key]; })[0];
                    return (
                      <div key={r.id||i} style={{background:D3,border:"1px solid "+BR,borderRadius:14,padding:"1.25rem",
                        display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:10}}>
                        <div style={{display:"flex",alignItems:"center",gap:14}}>
                          <Avatar s={initials(r.aluno_nome)} size={44}/>
                          <div>
                            <div style={{fontWeight:600,fontSize:15,color:"#fff"}}>{r.aluno_nome}</div>
                            <div style={{fontSize:12,color:T2}}>{new Date(r.created_at).toLocaleDateString("pt-BR")} · Prioridade: <span style={{color:G}}>{pior.icon} {pior.label}</span></div>
                          </div>
                        </div>
                        <div style={{display:"flex",alignItems:"center",gap:10,flexWrap:"wrap"}}>
                          <div style={{textAlign:"right"}}>
                            <div style={{fontSize:22,fontWeight:700,color:cl.cor}}>{r.media_geral}</div>
                            <span style={{fontSize:11,padding:"3px 10px",borderRadius:20,background:cl.bg,color:cl.cor,fontWeight:600}}>{cl.label}</span>
                          </div>
                          <button onClick={function(){ setAlunoSel(r); }} style={{background:G+"22",border:"1px solid "+G+"44",borderRadius:8,padding:"8px 14px",color:G,fontSize:12,cursor:"pointer",fontWeight:500}}>Ver dashboard</button>
                          <button onClick={async function(){
                            if (!window.confirm("Apagar diagnóstico de "+r.aluno_nome+"?")) return;
                            var ok = await apagarResposta(r.id);
                            if (ok) carregarDados();
                          }} style={{background:"#E5393522",border:"1px solid #E5393544",borderRadius:8,padding:"8px 14px",color:"#E53935",fontSize:12,cursor:"pointer",fontWeight:500}}>🗑</button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              );
            })()}
          </div>
        )}

        {view==="links" && (
          <div style={{padding:"2rem"}}>
            <div style={{marginBottom:24}}><div style={{fontSize:20,fontWeight:700,color:"#fff"}}>Diagnósticos</div><div style={{fontSize:12,color:T2}}>Gere links e envie para seus alunos preencherem</div></div>

            {/* Barra de uso do plano */}
            {user && user.plano !== "pro" && (
              <div style={{background:D3,border:"1px solid "+BR,borderRadius:12,padding:"1rem 1.25rem",marginBottom:20}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
                  <div style={{fontSize:13,color:TX}}>Plano <span style={{color:G,fontWeight:600}}>Free</span> — {diagnosticosMes}/5 diagnósticos este mês</div>
                  <button onClick={function(){ criarCheckout(user.id, user.email); }}
                    style={{background:G,color:D,border:"none",borderRadius:8,padding:"8px 16px",fontWeight:700,fontSize:12,cursor:"pointer"}}>
                    ⚡ Upgrade Pro — R$97/mês
                  </button>
                </div>
                <div style={{background:D4,borderRadius:4,height:6}}>
                  <div style={{background:diagnosticosMes>=5?"#E53935":G,height:6,borderRadius:4,width:Math.min(diagnosticosMes/5*100,100)+"%",transition:"width .3s"}}/>
                </div>
              </div>
            )}

            {/* Paywall */}
            {user && user.plano !== "pro" && diagnosticosMes >= 5 ? (
              <div style={{background:D3,border:"2px solid "+G+"44",borderRadius:14,padding:"2.5rem",textAlign:"center",marginBottom:24}}>
                <div style={{fontSize:48,marginBottom:16}}>🔒</div>
                <div style={{fontSize:20,fontWeight:700,color:"#fff",marginBottom:8}}>Limite do plano Free atingido</div>
                <div style={{fontSize:14,color:T2,marginBottom:24,lineHeight:1.7}}>Usaste os 5 diagnósticos gratuitos deste mês.<br/>Faz upgrade para o plano Pro e gera diagnósticos ilimitados.</div>
                <div style={{display:"flex",gap:16,justifyContent:"center",marginBottom:24,flexWrap:"wrap"}}>
                  {["✅ Diagnósticos ilimitados","✅ Notificações por email","✅ Relatórios PDF","✅ Suporte prioritário"].map(function(f){
                    return <div key={f} style={{background:D4,borderRadius:8,padding:"8px 16px",fontSize:13,color:TX}}>{f}</div>;
                  })}
                </div>
                <button onClick={function(){ criarCheckout(user.id, user.email); }}
                  style={{background:G,color:D,border:"none",borderRadius:10,padding:"16px 40px",fontWeight:700,fontSize:16,cursor:"pointer"}}>
                  ⚡ Assinar Pro — R$97/mês
                </button>
              </div>
            ) : (
              <div style={{background:D3,border:"1px solid "+BR,borderRadius:14,padding:"1.5rem",marginBottom:24}}>
              <div style={{fontSize:13,fontWeight:600,color:G,marginBottom:14}}>🔗 Gerar link de diagnóstico</div>
              <div style={{display:"flex",gap:10,marginBottom:linkGerado?14:0}}>
                <input value={novoNome} onChange={function(e){ setNovoNome(e.target.value); }} placeholder="Nome do aluno..." style={{...inp,flex:1,background:D4}} onKeyDown={function(e){ if(e.key==="Enter") gerarLink(); }}/>
                <button onClick={gerarLink} style={{background:G,color:D,border:"none",borderRadius:8,padding:"0 20px",fontWeight:600,fontSize:13,cursor:"pointer",whiteSpace:"nowrap"}}>Gerar link</button>
              </div>

              {/* Link Universal */}
              <div style={{marginTop:16,paddingTop:16,borderTop:"1px solid "+BR}}>
                <div style={{fontSize:13,fontWeight:600,color:"#A78BFA",marginBottom:10}}>🌐 Link universal (múltiplos alunos)</div>
                <div style={{fontSize:12,color:T2,marginBottom:12}}>Gera um único link que pode ser partilhado com qualquer pessoa. O aluno preenche os próprios dados ao entrar.</div>
                <button onClick={gerarLinkUniversalFn} style={{background:"#A78BFA22",color:"#A78BFA",border:"1px solid #A78BFA44",borderRadius:8,padding:"10px 20px",fontWeight:600,fontSize:13,cursor:"pointer"}}>
                  🌐 Gerar link universal
                </button>
                {linkUniversal && (
                  <div style={{marginTop:14,background:D4,border:"1px solid #A78BFA55",borderRadius:10,padding:"16px 18px"}}>
                    <div style={{fontSize:11,color:T2,marginBottom:8}}>✅ Link universal gerado — partilha com quem quiseres!</div>
                    <div style={{display:"flex",gap:8,alignItems:"center"}}>
                      <input readOnly value={window.location.origin+"?token="+linkUniversal.token} style={{flex:1,background:D3,border:"1px solid #A78BFA55",borderRadius:8,padding:"11px 14px",fontSize:12,color:"#A78BFA",fontFamily:"monospace",boxSizing:"border-box",outline:"none"}}/>
                      <button onClick={function(){
                        navigator.clipboard.writeText(window.location.origin+"?token="+linkUniversal.token).then(function(){ alert("Link copiado!"); }).catch(function(){ alert("Selecione o link manualmente."); });
                      }} style={{background:"#A78BFA",color:"#fff",border:"none",borderRadius:8,padding:"11px 16px",fontWeight:700,fontSize:13,cursor:"pointer",whiteSpace:"nowrap"}}>📋 Copiar</button>
                    </div>
                    <div style={{fontSize:11,color:T2,marginTop:8}}>⚠️ Este link fica sempre ativo e pode ser usado por várias pessoas.</div>
                  </div>
                )}
              </div>
              {linkGerado && (
                <div style={{background:D4,border:"1px solid "+G+"55",borderRadius:10,padding:"16px 18px"}}>
                  <div style={{fontSize:11,color:T2,marginBottom:8}}>✅ Link gerado para <strong style={{color:"#fff"}}>{linkGerado.alunoNome}</strong></div>
                  <div style={{marginBottom:12}}>
                    <div style={{fontSize:11,color:T2,marginBottom:6}}>Link do formulário:</div>
                    <div style={{display:"flex",gap:8,alignItems:"center"}}>
                      <input readOnly value={window.location.origin+"?token="+linkGerado.token} style={{flex:1,background:D3,border:"1px solid "+G+"55",borderRadius:8,padding:"11px 14px",fontSize:12,color:G,fontFamily:"monospace",boxSizing:"border-box",outline:"none"}}/>
                      <button onClick={function(){
                        navigator.clipboard.writeText(window.location.origin+"?token="+linkGerado.token).then(function(){ alert("Link copiado!"); }).catch(function(){ alert("Selecione o link manualmente."); });
                      }} style={{background:G,color:D,border:"none",borderRadius:8,padding:"11px 16px",fontWeight:700,fontSize:13,cursor:"pointer",whiteSpace:"nowrap"}}>📋 Copiar</button>
                    </div>
                  </div>
                  <button onClick={async function(){
                    var lk = await buscarLink(linkGerado.token);
                    if (lk) setLinkAtivo(lk);
                  }} style={{background:G,color:D,border:"none",borderRadius:9,padding:"12px 24px",fontWeight:700,fontSize:14,cursor:"pointer",width:"100%"}}>
                    ▶ Abrir formulário do aluno (simulação)
                  </button>
                </div>
              )}
            </div>
            )}
            <div style={{fontSize:13,fontWeight:600,color:"#fff",marginBottom:12}}>Links gerados ({meusLinks.length})</div>
            {meusLinks.length===0 && <div style={{textAlign:"center",padding:"2rem",color:T2,background:D3,border:"1px solid "+BR,borderRadius:12}}>Nenhum link gerado ainda.</div>}
            <div style={{display:"flex",flexDirection:"column",gap:8}}>
              {meusLinks.map(function(l){
                return (
                  <div key={l.token} style={{background:D3,border:"1px solid "+BR,borderRadius:12,padding:"1rem 1.25rem"}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                      <div>
                        <div style={{fontWeight:600,fontSize:14,color:"#fff"}}>{l.aluno_nome}</div>
                        <div style={{fontSize:11,color:T2,marginTop:2}}>Token: <span style={{fontFamily:"monospace",color:G}}>{l.token}</span> · {new Date(l.created_at).toLocaleDateString("pt-BR")}</div>
                      </div>
                      <div style={{display:"flex",alignItems:"center",gap:10}}>
                        <span style={{fontSize:11,padding:"4px 12px",borderRadius:20,background:l.is_active?"#FF980022":"#4CAF5022",color:l.is_active?"#FF9800":"#4CAF50",fontWeight:600}}>{l.is_active?"⏳ Aguardando":"✓ Respondido"}</span>
                        {l.is_active && <button onClick={async function(){
                          var lk = await buscarLink(l.token);
                          if (lk) setLinkAtivo(lk);
                        }} style={{background:G+"22",border:"1px solid "+G+"44",borderRadius:7,padding:"6px 12px",color:G,fontSize:11,cursor:"pointer",fontWeight:500}}>▶ Simular</button>}
                        <button onClick={async function(){
                          if (!window.confirm("Apagar link de "+l.aluno_nome+"?")) return;
                          var ok = await apagarLink(l.token);
                          if (ok) carregarDados();
                        }} style={{background:"#E5393522",border:"1px solid #E5393544",borderRadius:7,padding:"6px 12px",color:"#E53935",fontSize:11,cursor:"pointer",fontWeight:500}}>🗑</button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {view==="config" && <Config user={user} onSalvar={salvarConfig} msg={configMsg}/>}

      </div>
    </div>
  );
}
